import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';

import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { init } from '../editorconfig';
import { EditorModule } from '@tinymce/tinymce-angular';
import { UploadModule } from '../../modal/upload/upload.module';
import { ApiService } from '../../services/api.service';
import { ViewFromComponent } from '../../components/viewFromComponent';
@Component({
  standalone: true,
  selector: 'app-tdf-from',
  imports: [CommonModule, FormsModule, ReactiveFormsModule,DropdownModule,ToastModule,EditorModule,UploadModule,ViewFromComponent],
  providers: [MessageService],
  template:`
  <div class="mx-automin-h-screen">
    <app-view-from *ngIf="isViewOnly" [data]="tdfForm.value" [keys]="keys" ></app-view-from>
    <form *ngIf="!isViewOnly" [formGroup]="tdfForm" class="space-y-6">
  
      <!-- Header Section -->
      <div *ngIf="!stepDetails" class="bg-white p-6 shadow-md border border-slate-200 rounded-lg">
        <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
          <!-- DOI Reference Question -->
          <div class="flex flex-col justify-end">
            <label class="block text-sm font-bold text-blue-900 uppercase tracking-wider mb-3">
              Is this proposal in reference to a requirement requested by the DOI?
            </label>
            <div class="flex items-center gap-6">
              <div class="flex items-center gap-2">
                <input type="radio" id="seek_proposalYes" formControlName="seek_proposal" [value]="true" class="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500" />
                <label for="seek_proposalYes" class="mb-0 text-sm font-medium text-gray-700">Yes</label>
              </div>
              <div class="flex items-center gap-2">
                <input type="radio" id="seek_proposalNo" formControlName="seek_proposal" [value]="false" class="w-4 h-4 text-blue-600 border-gray-300 focus:ring-blue-500" />
                <label for="seek_proposalNo" class="mb-0 text-sm font-medium text-gray-700">No</label>
              </div>
            </div>
          </div>
          
          <!-- Proposal Name -->
          <div>
            <label for="proposalName" class="block text-sm font-bold text-blue-900 uppercase tracking-wider mb-3">
             Title of the Requirement (Including product/ system/ item/ etc.) <span class="text-red-600">*</span>
            </label>
            <input 
              id="proposalName"
              type="text"
              formControlName="proposalName"
              autocomplete="off"
              class="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none bg-white transition-all"
              placeholder="Enter proposal name"
            />
            <div *ngIf="tdfForm.get('proposalName')?.invalid && tdfForm.get('proposalName')?.touched" class="text-red-600 text-xs mt-1.5">
              Proposal Name is required
            </div>
          </div>
        </div>
      </div>
  
      <!-- Section 2: System Description & Justification -->
      <details class="group bg-white border border-slate-200 shadow-md rounded-lg overflow-hidden" open>
        <summary class="flex justify-between items-center px-6 py-4 cursor-pointer bg-blue-950 text-white font-bold uppercase tracking-wide hover:bg-blue-900 transition-all">
          <span class="text-base">2. System Description & Justification</span>
          <span class="transition-transform duration-300 group-open:rotate-180 text-blue-400 text-xl"><i class="pi pi-chevron-down"></i></span>
        </summary>
        <div class="p-6 space-y-6 bg-gradient-to-br from-blue-50/50 to-slate-50">
          
          <!-- 2(a) Description -->
          <div class="flex flex-col">
            <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
              2(a) Description of major system/sub-system and where the item/ product is to be utilised/ fitted.
            </label>
            <div class="rounded-b border border-blue-200 bg-white">
              <editor formControlName="major_description" [init]="init"></editor>
            </div>
          </div>
  
          <!-- 2(b) Reason -->
          <div class="flex flex-col">
            <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
              2(b) Reason for pursuing project under TDF scheme.
            </label>
            <div class="rounded-b border border-blue-200 bg-white">
              <editor formControlName="reason_pursuing" [init]="init"></editor>
            </div>
          </div>
  
        </div>
      </details>
  
      <!-- Section 3 & 4: Technology Area and Objective -->
      <div class="bg-white p-6 border border-slate-200 shadow-md rounded-lg space-y-6">
        
        <!-- 3. Technology Area -->
        <div class="flex flex-col">
          <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
            3. Technology Area (Discipline, Sub-discipline etc).
          </label>
          <div class="rounded-b border border-blue-200 bg-white">
            <editor formControlName="technology_area" [init]="init"></editor>
          </div>
        </div>
  
        <!-- 4. Objective -->
        <div class="flex flex-col">
          <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
            4. Objective (to cover product/ system/ Item).
          </label>
          <div class="rounded-b border border-blue-200 bg-white">
            <editor formControlName="objective" [init]="init"></editor>
          </div>
        </div>
  
      </div>
  
      <!-- Section 5: Detailed Description & Problem Solving -->
      <details class="group bg-white border border-slate-200 shadow-md rounded-lg overflow-hidden">
        <summary class="flex justify-between items-center px-6 py-4 cursor-pointer bg-blue-950 text-white font-bold uppercase tracking-wide hover:bg-blue-900 transition-all">
          <span class="text-base">5. Description</span>
          <span class="transition-transform duration-300 group-open:rotate-180 text-blue-400 text-xl"><i class="pi pi-chevron-down"></i></span>
        </summary>
        <div class="p-6 space-y-6 bg-gradient-to-br from-slate-50 to-blue-50/30">
  
          <!-- 5.1 Details of existing system -->
          <div class="flex flex-col">
            <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
              5.1 Details of existing system and its use
            </label>
            <div class="rounded-b border border-blue-200 bg-white">
              <editor formControlName="existing_system" [init]="init"></editor>
            </div>
          </div>
  
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div>
              <label class="block text-sm font-semibold text-blue-900 mb-3">5.2 Whether import/ available through indigenisation.</label>
              <input 
                type="text" 
                formControlName="import_indigenisation" 
                class="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none bg-white transition-all"
                placeholder="Enter details"
              />
            </div>
            <div>
              <label class="block text-sm font-semibold text-blue-900 mb-3">5.3 Cost of Present System/ LPP details.</label>
              <input 
                type="number" 
                formControlName="cost_system" 
                class="w-full border border-slate-300 rounded-lg px-4 py-2.5 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none bg-white transition-all"
                placeholder="Enter cost"
              />
            </div>
          </div>
  
          <!-- 5.4 Deficiencies -->
          <div class="flex flex-col">
            <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
              5.4 Deficiency in the existing system.
            </label>
            <div class="rounded-b border border-blue-200 bg-white">
              <editor formControlName="deficiency_system" [init]="init"></editor>
            </div>
          </div>
  
          <!-- 5.5 How deficiency plugged -->
          <div class="flex flex-col">
            <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
              5.5 How deficiency plugged/addressed presently
            </label>
            <div class="rounded-b border border-blue-200 bg-white">
              <editor formControlName="deficiency_plugged" [init]="init"></editor>
            </div>
          </div>
  
          <!-- 5.6 What will proposed system do -->
          <div class="flex flex-col">
            <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
              5.6 What will proposed system do
            </label>
            <div class="rounded-b border border-blue-200 bg-white">
              <editor formControlName="proposed_system" [init]="init"></editor>
            </div>
          </div>
  
          <!-- 5.7 Who will use -->
          <div class="flex flex-col">
            <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
              5.7 Who will use the system and how
            </label>
            <div class="rounded-b border border-blue-200 bg-white">
              <editor formControlName="use_system" [init]="init"></editor>
            </div>
          </div>
  
          <!-- 5.8 What problem will this solve -->
          <div class="flex flex-col">
            <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
              5.8 What problem will this solve
            </label>
            <div class="rounded-b border border-blue-200 bg-white">
              <editor formControlName="problem_solve" [init]="init"></editor>
            </div>
          </div>
  
        </div>
      </details>
  
      <!-- Section 6: Functional & Operational (Qualitative) -->
      <details class="group bg-white border border-slate-200 shadow-md rounded-lg overflow-hidden">
        <summary class="flex justify-between items-center px-6 py-4 cursor-pointer bg-blue-950 text-white font-bold uppercase tracking-wide hover:bg-blue-900 transition-all">
          <span class="text-base">6. Functional and Operational requirements in Qualitative terms</span>
          <span class="transition-transform duration-300 group-open:rotate-180 text-blue-300 text-xl"><i class="pi pi-chevron-down"></i></span>
        </summary>
        <div class="p-6 space-y-6 bg-gradient-to-br from-slate-50 to-blue-50/30">
  
          <!-- 6.1 Functional Parameters -->
          <div class="flex flex-col">
            <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
              6.1 Functional Parameters
            </label>
            <div class="rounded-b border border-blue-200 bg-white">
              <editor formControlName="functional_parameters" [init]="init"></editor>
            </div>
          </div>
  
          <!-- 6.2 Physical Constraints -->
          <div class="flex flex-col">
            <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
              6.2 Physical Constraints
            </label>
            <div class="rounded-b border border-blue-200 bg-white">
              <editor formControlName="physical_constraints" [init]="init"></editor>
            </div>
          </div>
  
          <!-- 6.3 Environmental Requirements -->
          <div class="flex flex-col">
            <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
              6.3 Environmental Requirements
            </label>
            <div class="rounded-b border border-blue-200 bg-white">
              <editor formControlName="environmental_requirements" [init]="init"></editor>
            </div>
          </div>
  
          <!-- 6.4 Reliability/Maintainability -->
          <div class="flex flex-col">
            <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
              6.4 Reliability/Maintainability
            </label>
            <div class="rounded-b border border-blue-200 bg-white">
              <editor formControlName="reliability_maintainability" [init]="init"></editor>
            </div>
          </div>
  
          <!-- 6.5 Usability -->
          <div class="flex flex-col">
            <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
              6.5 Usability
            </label>
            <div class="rounded-b border border-blue-200 bg-white">
              <editor formControlName="usability" [init]="init"></editor>
            </div>
          </div>
  
          <!-- 6.6 Any Other Information -->
          <div class="flex flex-col">
            <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
              6.6 Any Other Information
            </label>
            <div class="rounded-b border border-blue-200 bg-white">
              <editor formControlName="any_other" [init]="init"></editor>
            </div>
          </div>
  
        </div>
      </details>
  
      <!-- Section 7: Functional & Operational (Quantitative) -->
      <details class="group bg-white border border-slate-200 shadow-md rounded-lg overflow-hidden">
        <summary class="flex justify-between items-center px-6 py-4 cursor-pointer bg-blue-950 text-white font-bold uppercase tracking-wide hover:bg-blue-900 transition-all">
          <span class="text-base">7. Functional and Operational requirements in Quantitative terms</span>
          <span class="transition-transform duration-300 group-open:rotate-180 text-blue-300 text-xl"><i class="pi pi-chevron-down"></i></span>
        </summary>
        <div class="p-6 space-y-6 bg-gradient-to-br from-slate-50 to-blue-50/30">
  
          <!-- 7.1 Functional Specification -->
          <div class="flex flex-col">
            <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
              7.1 Functional Specification
            </label>
            <div class="rounded-b border border-blue-200 bg-white">
              <editor formControlName="functional_specification" [init]="init"></editor>
            </div>
          </div>
  
          <!-- 7.2 Physical Specification -->
          <div class="flex flex-col">
            <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
              7.2 Physical Specification
            </label>
            <div class="rounded-b border border-blue-200 bg-white">
              <editor formControlName="physical_specification" [init]="init"></editor>
            </div>
          </div>
  
          <!-- 7.3 Environmental Spec -->
          <div class="flex flex-col">
            <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
              7.3 Environmental Specification
            </label>
            <div class="rounded-b border border-blue-200 bg-white">
              <editor formControlName="environmental_specification" [init]="init"></editor>
            </div>
          </div>
  
          <!-- 7.4 R & M Specification -->
          <div class="flex flex-col">
            <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
              7.4 Reliability and maintainability specifications
            </label>
            <div class="rounded-b border border-blue-200 bg-white">
              <editor formControlName="reliability_specification" [init]="init"></editor>
            </div>
          </div>
  
          <!-- 7.5 Usability Spec -->
          <div class="flex flex-col">
            <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
              7.5 Usability
            </label>
            <div class="rounded-b border border-blue-200 bg-white">
              <editor formControlName="usability_specification" [init]="init"></editor>
            </div>
          </div>
  
          <!-- 7.6 Any Other Relevant Info -->
          <div class="flex flex-col">
            <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
              7.6 Any Other Relevant Information
            </label>
            <div class="rounded-b border border-blue-200 bg-white">
              <editor formControlName="other_specification" [init]="init"></editor>
            </div>
          </div>
  
        </div>
      </details>
  
      <!-- Sections 8-14 -->
      <div class="bg-white p-6 border border-slate-200 shadow-md rounded-lg space-y-6">
  
        <!-- 8. Contemporary Solutions -->
        <div class="flex flex-col">
          <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
            8. Contemporary solutions known nationally and/or internationally (if nil, then source of idea)
          </label>
          <div class="rounded-b border border-blue-200 bg-white">
            <editor formControlName="contemporary_solution" [init]="init"></editor>
          </div>
        </div>
  
        <!-- 9. Miscellaneous Information -->
        <div class="flex flex-col">
          <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
            9. Miscellaneous Information
          </label>
          <div class="rounded-b border border-blue-200 bg-white">
            <editor formControlName="miscellaneous_information" [init]="init"></editor>
          </div>
        </div>
  
        <!-- 10. References -->
        <div class="flex flex-col">
          <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
            10. References
          </label>
          <div class="rounded-b border border-blue-200 bg-white">
            <editor formControlName="references" [init]="init"></editor>
          </div>
        </div>
  
        <!-- 11. Keywords -->
        <div class="flex flex-col">
          <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
            11. Keywords
          </label>
          <div class="rounded-b border border-blue-200 bg-white">
            <editor formControlName="keywords" [init]="init"></editor>
          </div>
        </div>
  
        <!-- 12. Estimated Requirement -->
        <div class="flex flex-col">
          <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
            12. Estimated requirement for the Indian Navy over three to five years including number of prototypes required and likely delivery location of prototype
          </label>
          <div class="rounded-b border border-blue-200 bg-white">
            <editor formControlName="estimated_requirement" [init]="init"></editor>
          </div>
        </div>
  
        <!-- 13. Testing Methodology -->
        <div class="flex flex-col">
          <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
            13. Testing Methodology, Free Issue Material, Acceptance Criteria/ Type Tests Required / Venue of testing
          </label>
          <div class="rounded-b border border-blue-200 bg-white">
            <editor formControlName="testing_methodology" [init]="init"></editor>
          </div>
        </div>
  
        <!-- 14. Likely Civil Spin-Offs -->
        <div class="flex flex-col">
          <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
            14. Likely Civil Spin Offs (if envisaged)
          </label>
          <div class="rounded-b border border-blue-200 bg-white">
            <editor formControlName="civil_spin" [init]="init"></editor>
          </div>
        </div>
  
      </div>
  
      <!-- Sections 15-19 -->
      <div class="bg-white p-6 rounded-lg border border-slate-200 shadow-md space-y-6">
  
        <!-- 15. Technology Readiness Level -->
        <div class="flex flex-col">
          <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
            15. Technology Readiness Level (Whether the proposed technology has been demonstrated in India and needs scaling up/ modification and not an academic project)
          </label>
          <div class="rounded-b border border-blue-200 bg-white">
            <editor formControlName="technology_readiness" [init]="init"></editor>
          </div>
        </div>
  
        <!-- 16. Proposal Explanation -->
        <div class="flex flex-col">
          <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
            16. Feasibility Studies (attach if available)          </label>
          <div class="rounded-b border border-blue-200 bg-white">
            <editor formControlName="feasibility_studies" [init]="init"></editor>
          </div>
        </div>
        <div class="flex flex-col">
          <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
            17. Proposal is an equipment/ spare (is it an import substitute/ replacement/ upgrade/ new induction). Brief explanation
          </label>
          <div class="rounded-b border border-blue-200 bg-white">
            <editor formControlName="proposal_explain" [init]="init"></editor>
          </div>
        </div>
  
        <!-- 17. QA Agency -->
        <div class="flex flex-col">
          <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
            18. QA Agency (DQA/ CEMILAC etc)
          </label>
          <div class="rounded-b border border-blue-200 bg-white">
            <editor formControlName="qa_agency" [init]="init"></editor>
          </div>
        </div>
  
        <!-- 18 & 19 Checkboxes -->
        <div class="flex flex-col sm:flex-row gap-6 py-6 border-t border-slate-200">
          <label class="inline-flex items-center cursor-pointer group">
            <input 
              type="checkbox" 
              formControlName="classified_information" 
              class="w-5 h-5 text-blue-600 border-slate-300 rounded focus:ring-2 focus:ring-blue-500 transition-all"
            />
            <span class="ml-3 text-sm font-medium text-slate-700 group-hover:text-blue-900 transition-colors">19. Whether any classified information included in SoC (Yes/No)?</span>
          </label>
          
          <label class="inline-flex items-center cursor-pointer group">
            <input 
              type="checkbox" 
              formControlName="concurrence_apso" 
              class="w-5 h-5 text-blue-600 border-slate-300 rounded focus:ring-2 focus:ring-blue-500 transition-all"
            />
            <span class="ml-3 text-sm font-medium text-slate-700 group-hover:text-blue-900 transition-colors">20. Concurrence by APSO accorded date (Yes/ No)</span>
          </label>
        </div>

        <!-- 22. Nodal Officer Details -->
        <div class="flex flex-col gap-2 py-4 border-t border-slate-200">
          <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
            22. Details of Nodal Officer who shall execute the project
          </label>
          <div class="rounded-b border border-blue-200 bg-white p-4 flex flex-col gap-4">
            <!-- <div class="flex flex-col sm:flex-row gap-6">
              <div class="flex-1">
                <label class="block mb-1 font-medium text-slate-700">Name</label>
                <input 
                  type="text" 
                  formControlName="nodal_officer_name" 
                  class="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                  placeholder="Enter Nodal Officer Name"
                />
              </div>
            
            </div> -->
            <div class="flex flex-col sm:flex-row gap-6">
  <!-- Landline -->
        <div class="flex-1">
          <label class="block mb-1 font-medium text-slate-700">
            Landline <span class="text-red-600">*</span>
          </label>
          <input
            type="tel"
            formControlName="nodal_officer_landline"
            class="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Enter Landline Number"
          />

          <div
            *ngIf="tdfForm.get('nodal_officer_landline')?.touched && tdfForm.get('nodal_officer_landline')?.invalid"
            class="mt-1 text-sm text-red-600"
          >
            <div *ngIf="tdfForm.get('nodal_officer_landline')?.errors?.['required']">
              Landline number is required.  Example: 02212345678
            </div>
          
            <div *ngIf="tdfForm.get('nodal_officer_landline')?.errors?.['minlength']">
              Landline number must be at least 11 digits.Example: 02212345678
            </div>
            <div *ngIf="tdfForm.get('nodal_officer_landline')?.errors?.['maxlength']">
              Landline number must not exceed 11 digits. Example: 02212345678
            </div>
          </div>
        </div>

  <!-- Mobile -->
  <div class="flex-1">
    <label class="block mb-1 font-medium text-slate-700">
      Mobile <span class="text-red-600">*</span>
    </label>
    <input
      type="tel"
      formControlName="nodal_officer_mobile"
      class="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
      placeholder="Enter Mobile Number"
    />

    <div
      *ngIf="tdfForm.get('nodal_officer_mobile')?.touched && tdfForm.get('nodal_officer_mobile')?.invalid"
      class="mt-1 text-sm text-red-600"
    >
      <div *ngIf="tdfForm.get('nodal_officer_mobile')?.errors?.['required']">
        Mobile number is required.
      </div>
      <div *ngIf="tdfForm.get('nodal_officer_mobile')?.errors?.['pattern']">
        Enter a valid 10-digit mobile number.
      </div>
    </div>
  </div>

  <!-- Email -->
  <div class="flex-1">
    <label class="block mb-1 font-medium text-slate-700">
      Email <span class="text-red-600">*</span>
    </label>
    <input
      type="email"
      formControlName="nodal_officer_email"
      class="w-full px-3 py-2 border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
      placeholder="Enter Email"
    />

    <div
      *ngIf="tdfForm.get('nodal_officer_email')?.touched && tdfForm.get('nodal_officer_email')?.invalid"
      class="mt-1 text-sm text-red-600"
    >
      <div *ngIf="tdfForm.get('nodal_officer_email')?.errors?.['required']">
        Email is required.
      </div>
      <div *ngIf="tdfForm.get('nodal_officer_email')?.errors?.['email']">
        Enter a valid email address.
      </div>
    </div>
  </div>
</div>
          </div>
        </div>
        <div class="flex flex-col">
          <label class="font-semibold text-base bg-blue-800 text-white px-3 py-2 rounded-t">
            23. Any Other Information
          </label>
          <div class="rounded-b border border-blue-200 bg-white">
            <editor formControlName="any_other_information" [init]="init"></editor>
          </div>
        </div>
  
      </div>
  
      <!-- Document Upload Section -->
      
    </form>
    <details class="group bg-white border border-slate-200 shadow-md rounded-lg overflow-hidden mt-4" [open]="isFeasibilityOpen" (toggle)="isFeasibilityOpen = !isFeasibilityOpen">
      <summary class="flex justify-between items-center px-6 py-4 cursor-pointer bg-blue-950 text-white font-bold uppercase tracking-wide hover:bg-blue-900 transition-all">
        <span class="text-base">Feasibility Studies, Photographs of Items, Other Documents</span>
        <span class="transition-transform duration-300 group-open:rotate-180 text-blue-300 text-xl"><i class="pi pi-chevron-down"></i></span>
      </summary>
      <div class="p-6 bg-gradient-to-br from-slate-50 to-blue-50/30" *ngIf="isFeasibilityOpen">
        <ng-container *ngIf="!isFirstStepDocx && !fristStepData; else otherSteps">
          <app-upload-document 
            [isEditable]="true" 
            [dmsFiles]="proposalForm?.dms_files || []" 
            [isSaveVied]="true" 
            (uploadData)="onDocumentUpload($event)">
          </app-upload-document>
        </ng-container>
        <ng-template #otherSteps>
          <app-upload-document 
            [isEditable]="stepDetails?.can_edit" 
            [proposal_step]="fristStepData?.id">
          </app-upload-document>
        </ng-template>
      </div>
    </details>
  </div>

  `
})
export class TdfFromComponent implements OnInit{

    @Input() url: string = '';
    @Input() isViewOnly: boolean = false;
    @Input() proposalForm: any;
    @Input() stepDetails: any;
    @Input() isFirstStepDocx=false
    @Output() submitFormEvent = new EventEmitter<any>();

    init: EditorComponent['init'] = init;
    isFeasibilityOpen:boolean=false;
    tdfForm: FormGroup;
    selectedDmsFiles: any[] = [];
    constructor(private fb: FormBuilder, private apiService: ApiService) {
      this.tdfForm = this.fb.group({
        id: [null],
        seek_proposal: [false],
        proposalName: ['', Validators.required],
        title: [''],
        major_description: [''],
        reason_pursuing: [''],
        technology_area: [''],
        objective: [''],
        existing_system: [''],
        import_indigenisation: [''],
        cost_system: [null],
        deficiency_system: [''],
        deficiency_plugged: [''],
        proposed_system: [''],
        use_system: [''],
        problem_solve: [''],
        functional_parameters: [''],
        physical_constraints: [''],
        environmental_requirements: [''],
        reliability_maintainability: [''],
        usability: [''],
        any_other: [''],
        functional_specification: [''],
        physical_specification: [''],
        environmental_specification: [''],
        reliability_specification: [''],
        usability_specification: [''],
        other_specification: [''],
        contemporary_solution: [''],
        miscellaneous_information: [''],
        references: [''],
        keywords: [''],
        estimated_requirement: [''],
        testing_methodology: [''],
        civil_spin: [''],
        technology_readiness: [''],
        proposal_explain: [''],
        qa_agency: [''],
        classified_information: [false],
        concurrence_apso: [false],
        feasibility_studies:[''],
        nodal_officer_landline: [
          '',
          [
            Validators.required,
            Validators.pattern(/^[0-9]+$/),
            Validators.minLength(11),
            Validators.maxLength(11)
          ]
        ],
        nodal_officer_mobile: [
          '',
          [
            Validators.required,
            Validators.pattern(/^[6-9][0-9]{9}$/)
          ]
        ],
        nodal_officer_email: [
          '',
          [
            Validators.required,
            Validators.email
          ]
        ],
        any_other_information: [''],
       
      });
    }

    ngOnInit(): void {
      console.log(this.proposalForm);
      if(this.proposalForm){
        this.tdfForm.patchValue(this.proposalForm);
        this.tdfForm.get('proposalName')?.setValue(this.proposalForm?.proposal_name );
        this.selectedDmsFiles = this.proposalForm?.dms_files || [];
      }
      if(this.isFirstStepDocx){
        this.getFristStep();
      }
      if(this.stepDetails){
        this.getChallenge();
        (this.stepDetails?.can_edit)? this.tdfForm.enable() : this.tdfForm.disable();
      }
  }
    onDocumentUpload(data: any) {
      this.selectedDmsFiles.push(data);
    }

    submitForm() {
      this.submitFormEvent.emit({tdfForm:this.tdfForm.value,selectedDmsFiles:this.selectedDmsFiles});
      this.selectedDmsFiles=[]
    }

    populateDraftProposal(draft: any) {
      this.tdfForm.patchValue(draft);
      this.tdfForm.get('proposalName')?.setValue(draft?.proposal_name );
      this.stepDetails? this.selectedDmsFiles = draft?.dms_files || [] : '';
    }
    getChallenge() {
      this.apiService.getAPI(`${this.url}?proposal_step=${this.stepDetails.id}&proposal_step__proposal=${this.stepDetails.proposal}`).subscribe((res: any) => {
        if(['makeI_02','A-VCNS'].includes(this.stepDetails.code)) {
          this.populateDraftProposal(res.need_generation);
        } else {
          this.populateDraftProposal(res[0]);
        }
      });
     }

     fristStepData:any;
     getFristStep(){
      this.apiService.getAPI(`/transaction/copy/proposals/${this.stepDetails?.proposal}/steps/?code=T-IP`).subscribe((res: any) => {
        this.fristStepData = res[0];
      });
     }

     stepSaveApiCall(){
      this.apiService.putAPI(`${this.url}${this.tdfForm?.value?.id}/`, this.tdfForm.value).subscribe((res: any) => {
        
      });
     }

     keys: any[] = [
      { label: 'Is this proposal in reference to a requirement requested by the DOI?', key: 'seek_proposal', cellMargin: 1},
    
      { label: 'Title of the Requirement (Including product/ system/ item/ etc.)', key: 'proposalName', cellMargin: 1 },
    
      { label: '2(a) Description of major system/sub-system and where the item/ product is to be utilised/ fitted.', key: 'major_description', cellMargin: 1 },
      { label: '2(b) Reason for pursuing project under TDF scheme.', key: 'reason_pursuing', cellMargin: 1 },
    
      { label: '3. Technology Area (Discipline, Sub-discipline etc).', key: 'technology_area', cellMargin: 1 },
      { label: '4. Objective (to cover product/ system/ Item).', key: 'objective', cellMargin: 1 },
    
      { label: '5. Description', key: '', cellMargin: 2 },
      { label: '5.1 Details of existing system and its use', key: 'existing_system', cellMargin: 1 },
      { label: '5.2 Whether import/ available through indigenisation.', key: 'import_indigenisation', cellMargin: 1 },
      { label: '5.3 Cost of Present System/ LPP details.', key: 'cost_system', cellMargin: 1 },
      { label: '5.4 Deficiency in the existing system.', key: 'deficiency_system', cellMargin: 1 },
      { label: '5.5 How deficiency plugged/addressed presently', key: 'deficiency_plugged', cellMargin: 1 },
      { label: '5.6 What will proposed system do', key: 'proposed_system', cellMargin: 1 },
      { label: '5.7 Who will use the system and how', key: 'use_system', cellMargin: 1 },
      { label: '5.8 What problem will this solve', key: 'problem_solve', cellMargin: 1 },
    
      { label: '6. Functional and Operational requirements in Qualitative terms', key: '', cellMargin: 2   },
      { label: '6.1 Functional Parameters', key: 'functional_parameters', cellMargin: 1   },
      { label: '6.2 Physical Constraints', key: 'physical_constraints', cellMargin: 1 },
      { label: '6.3 Environmental Requirements', key: 'environmental_requirements', cellMargin: 1 },
      { label: '6.4 Reliability/Maintainability', key: 'reliability_maintainability', cellMargin: 1 },
      { label: '6.5 Usability', key: 'usability', cellMargin: 1 },
      { label: '6.6 Any Other Information', key: 'any_other', cellMargin: 1 },
    
      { label: '7. Functional and Operational requirements in Quantitative terms', key: '', cellMargin: 2 },
      { label: '7.1 Functional Specification', key: 'functional_specification', cellMargin: 1 },
      { label: '7.2 Physical Specification', key: 'physical_specification', cellMargin: 1 },
      { label: '7.3 Environmental Specification', key: 'environmental_specification', cellMargin: 1 },
      { label: '7.4 Reliability and maintainability specifications', key: 'reliability_specification', cellMargin: 1 },
      { label: '7.5 Usability', key: 'usability_specification', cellMargin: 1 },
      { label: '7.6 Any Other Relevant Information', key: 'other_specification', cellMargin: 1 },
    
      { label: '8. Contemporary solutions known nationally and/or internationally (if nil, then source of idea)', key: 'contemporary_solution', cellMargin: 1 },
      { label: '9. Miscellaneous Information', key: 'miscellaneous_information', cellMargin: 1 },
      { label: '10. References', key: 'references', cellMargin: 1 },
      { label: '11. Keywords', key: 'keywords', cellMargin: 1 },
      { label: '12. Estimated requirement for the Indian Navy over three to five years including number of prototypes required and likely delivery location of prototype', key: 'estimated_requirement' },
      { label: '13. Testing Methodology, Free Issue Material, Acceptance Criteria/ Type Tests Required / Venue of testing', key: 'testing_methodology', cellMargin: 1    },
      { label: '14. Likely Civil Spin Offs (if envisaged)', key: 'civil_spin', cellMargin: 1 },
    
      { label: '15. Technology Readiness Level (Whether the proposed technology has been demonstrated in India and needs scaling up/ modification and not an academic project)', key: 'technology_readiness', cellMargin: 1 },
      { label: '16. Feasibility Studies (attach if available)', key: 'feasibility_studies', cellMargin: 1 },
      { label: '17. Proposal is an equipment/ spare (is it an import substitute/ replacement/ upgrade/ new induction). Brief explanation', key: 'proposal_explain', cellMargin: 1 },
      { label: '18. QA Agency (DQA/ CEMILAC etc)', key: 'qa_agency', cellMargin: 1 },
    
      { label: '19. Whether any classified information included in SoC (Yes/No)?', key: 'classified_information', cellMargin: 1 },
      { label: '20. Concurrence by APSO accorded date (Yes/ No)', key: 'concurrence_apso', cellMargin: 1 },
    
      { label: '22. Nodal Officer Landline', key: 'nodal_officer_landline', cellMargin: 1 },
      { label: '22. Nodal Officer Mobile', key: 'nodal_officer_mobile', cellMargin: 1 },
      { label: '22. Nodal Officer Email', key: 'nodal_officer_email', cellMargin: 1 },
    
      { label: '23. Any Other Information', key: 'any_other_information', cellMargin: 1 },
    ];
    
}